import { render } from "./ModalAddItem.vue?vue&type=template&id=671dfa1b"
import script from "./ModalAddItem.vue?vue&type=script&lang=js"
export * from "./ModalAddItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__